import { defineMessages } from 'react-intl';

const messages = defineMessages({
  basicInfo: '基本信息',
  qualifiedFile: '资质文件',
  serviceInfo: '服务信息',
  auditInfo: '审核信息',
  supplierContacts: '联系人',
  bankInfo: '银行账户信息',
  contractInfo: '合同信息',
  accountsInfo: '账号信息',
});

export default messages;
